export const useZendeskBot = () => {
  useHead({
    script: [
      {
        type: 'text/javascript',
        tagPosition: 'bodyClose',
        id: 'ze-snippet',
        src: 'https://static.zdassets.com/ekr/snippet.js?key=2ac79119-da03-43cb-b7ba-aea773498731',
        onload: `
          zE('messenger:set', 'zIndex', 0);
        `,
      },
    ],
  })
}
